import React, { Component } from 'react';
import { get } from 'lodash';

class Crumb extends Component {
  constructor(props) {
    super(props);

    this.id = get(this.props.group, 'id', null);
    this.name = get(
      this.props.group,
      'name',
      t('groups.system_generated.title'),
    );
  }

  handleClick = () => {
    this.props.updateActiveGroup(this.id);

    if (this.id === null) {
      this.props.updateMyOrganization(true);
    }
  };

  render() {
    return (
      <span
        role="button"
        tabIndex="0"
        className="ButtonLink SelecTable-actionButton c-brand-blue c-p"
        onClick={this.handleClick}
        aria-label={this.name}
        onKeyDown={e => e.key === 'Enter' && this.handleClick()}
      >
        {this.name}
      </span>
    );
  }
}

export default Crumb;
